import React, { Component } from 'react';
import { t } from 'ttag';
import Price from '../utils/prices';
import arrayToString from '../utils/js/arrayToString';

import client from '../utils/client';
import './style.less';

const overLay = document.getElementById('header-click-overlay');

export default class HeaderSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
      searchResults: null,
      isFocused: false,
      isHovering: false,
      currentIndex: 0
    };
    this.handleChange = this.handleChange.bind(this);
    this.searchProducts = this.searchProducts.bind(this);
    window.shouldHideHeaderOnScroll = true;
  }

  componentDidMount() {
    document.addEventListener('keydown', event => {
      const keyName = event.key;
      switch (keyName) {
        case 'ArrowUp':
          this.moveSelectUp();
          break;
        case 'ArrowDown':
          this.moveSelectDown();
          break;
        case 'Enter':
          if (this.state.isFocused) {
            this.goToPage();
          }
          break;
        default:
          break;
      }
    });
  }

  debounce = (callback, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => callback(...args), delay);
    };
  };

  goToPage() {
    window.location.href = `/search/?q=${this.state.inputValue}`;
  }

  moveSelectDown() {
    this.setState(prevState => ({
      currentIndex: prevState.currentIndex + 1
    }));
  }

  moveSelectUp = () => {
    if (this.state.currentIndex > 0) {
      this.setState(prevState => ({
        currentIndex: prevState.currentIndex - 1
      }));
    }
  };

  handleChange(event) {
    this.setState({ inputValue: event.target.value });
    this.searchProducts(event.target.value);
  }

  handleFocus() {
    this.setState({
      isFocused: true
    });
    if (this.state.searchResults !== null) {
      this.props.handleOverLay('HeaderSearch', true);
    } else {
      this.props.handleOverLay('HeaderSearch', false);
    }
    window.HeaderState.index = 0;
    window.HeaderState.show('searchActive');
    window.HeaderState.burgerMenuActive = false;
  }

  handleBlur() {
    this.setState(
      {
        isFocused: false
      },
      () => {
        if (!this.state.isHovering && !this.state.isFocused) {
          this.props.handleOverLay(null, false);
        }
      }
    );
  }

  onMouseEnter = () => {
    this.setState({
      isHovering: true
    });
  };

  onMouseLeave = () => {
    this.setState(
      {
        isHovering: false
      },
      () => {
        if (!this.state.isFocused) {
          this.props.handleOverLay(null);
        }
      }
    );
  };

  searchProducts = this.debounce(term => {
    client
      .get(`/api/search/?q=${term}&to=4&from=0&sort=default&suggestion=true`)
      .then(res => {
        this.setState({
          searchResults: res.data
        });
        if (this.state.searchResults !== null) {
          overLay.style.display = 'block';
          this.props.handleOverLay('HeaderSearch', true);
        }
      });
  }, 250);

  renderSearchResults = () => {
    const BFCondition = window.config.black_friday_ff;

    return this.state.searchResults.products.map(product => {
      try {
        const prices = product.prices || null;
        const rrp = new Price(prices.recommended_retail_price, prices.currency);
        const maxPrice = new Price(prices.max_price, prices.currency);
        const minPrice = new Price(prices.min_price, prices.currency);
        return (
          <li key={product.id}>
            <a
              className={`${this.props.flag ? 'result-new' : 'result'}`}
              href={`${product.relative_url || '#'}?search_query=${
                this.state.inputValue
              }`}
            >
              <img src={product.image} alt={product.name} />
              <div className="info">
                <span className="title">{product.name}</span>
                <div className="prices">
                  <span className="amount">
                    {prices && !minPrice.equals(maxPrice) && (
                      <span className="from">{`${t`From`} `}</span>
                    )}
                    {minPrice.toString()}
                  </span>
                  {prices &&
                  prices.discount_percentage > 0 &&
                  minPrice.equals(maxPrice) ? (
                    <span className="rrp">{rrp.toString()}</span>
                  ) : null}
                </div>
              </div>
              {prices &&
                prices.discount_percentage > 0 &&
                minPrice.equals(maxPrice) && (
                  <span
                    className={`search-splash ${arrayToString(BFCondition)}`}
                  >
                    {`-${prices.discount_percentage}%`}
                  </span>
                )}
            </a>
          </li>
        );
      } catch (e) {
        return null;
      }
    });
  };

  render() {
    window.searchActive = this.state.isFocused;
    const backgroundColour = this.props.flag ? '#0CD428' : '#00bf50';

    return (
      <div
        className={`search ${this.props.flag && 'new'}`}
        style={
          this.state.isFocused
            ? { background: backgroundColour }
            : { background: '#0CD428' }
        }
      >
        <div className="search-wrapper">
          <input
            type="text"
            name="search-query"
            id="search-query"
            data-testid="search-query-input"
            className={`search-query ${this.props.flag && 'new'}`}
            aria-label={t`Search the Unisport catalog of products`}
            autoComplete="off"
            placeholder={this.props.placeholder}
            onChange={e => this.handleChange(e)}
            onFocus={e => this.handleFocus(e)}
            onBlur={e => this.handleBlur(e)}
            value={this.state.inputValue}
          />
          <button
            onClick={() => this.goToPage()}
            aria-label={t`Search button.`}
            className={`search-submit ${this.props.flag && 'new'}`}
            type="submit"
            tabIndex="0"
            name="search"
          >
            {this.props.flag ? (
              <img
                className="search-icon"
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTE5LjggMTguNGwtNC44LTQuOGMwLjItMC4yIDAuMi0wLjMgMC4zLTAuNCAwLjEtMC4xIDAuMS0wLjEgMC4xLTAuMiAxLjktMi43IDEuNC02LjQtMS04LjkgLTEuMy0xLjQtMy4xLTIuMS01LjEtMi4xIC0xLjkgMC0zLjggMC43LTUuMiAyLjEgLTEuNCAxLjQtMi4yIDMuMy0yLjIgNS4xIDAgMiAwLjcgMy44IDIuMiA1LjEgMS4zIDEuNCAzLjIgMi4xIDUuMiAyLjEgMS4yIDAgMi4zLTAuMyAzLjQtMC44IDAuMi0wLjEgMC40LTAuMyAwLjctMC41bDQuOSA0LjdjMCAwIDAuMiAwLjEgMC40IDAuMSAwLjEgMCAwLjIgMCAwLjQtMC4xbDAuMi0wLjIgMC41LTAuNWMwLjItMC4yIDAuMS0wLjYtMC4xLTAuN1pNOS4zIDRjMi45IDAgNS4zIDIuNCA1LjMgNS4zIDAgMi45LTIuNCA1LjMtNS4zIDUuMyAtMi45IDAtNS4zLTIuNC01LjMtNS4zIDAtMi45IDIuNC01LjMgNS4zLTUuM1oiIGZpbGw9IiMyMTIzMzgiLz48L3N2Zz4="
                alt="search"
              />
            ) : (
              <img
                className="search-icon"
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTE5LjggMTguNGwtNC44LTQuOGMwLjItMC4yIDAuMi0wLjMgMC4zLTAuNCAwLjEtMC4xIDAuMS0wLjEgMC4xLTAuMiAxLjktMi43IDEuNC02LjQtMS04LjkgLTEuMy0xLjQtMy4xLTIuMS01LjEtMi4xIC0xLjkgMC0zLjggMC43LTUuMiAyLjEgLTEuNCAxLjQtMi4yIDMuMy0yLjIgNS4xIDAgMiAwLjcgMy44IDIuMiA1LjEgMS4zIDEuNCAzLjIgMi4xIDUuMiAyLjEgMS4yIDAgMi4zLTAuMyAzLjQtMC44IDAuMi0wLjEgMC40LTAuMyAwLjctMC41bDQuOSA0LjdjMCAwIDAuMiAwLjEgMC40IDAuMSAwLjEgMCAwLjIgMCAwLjQtMC4xbDAuMi0wLjIgMC41LTAuNWMwLjItMC4yIDAuMS0wLjYtMC4xLTAuN1pNOS4zIDRjMi45IDAgNS4zIDIuNCA1LjMgNS4zIDAgMi45LTIuNCA1LjMtNS4zIDUuMyAtMi45IDAtNS4zLTIuNC01LjMtNS4zIDAtMi45IDIuNC01LjMgNS4zLTUuM1oiIGZpbGw9IiMwYWJmNWEiLz48L3N2Zz4="
                alt="search"
              />
            )}
          </button>
          {this.state.searchResults !== null && this.props.isItemActive ? (
            <div
              id="search-popup"
              data-testid="search-popup"
              className={this.props.flag && 'newSearchHeader'}
              onMouseEnter={this.onMouseEnter}
              onMouseLeave={this.onMouseLeave}
              style={
                this.props.isItemActive
                  ? { display: 'block' }
                  : { display: 'none' }
              }
            >
              <div
                className={`autocomplete-results ${this.props.flag && 'new'}`}
              >
                {this.state.searchResults.navigation_items &&
                  this.state.searchResults.navigation_items.length > 0 && (
                    <div
                      className="category-results"
                      data-testid="category-results"
                    >
                      <div
                        className={`${
                          this.props.flag ? 'header-new' : 'header'
                        }`}
                      >
                        <p>
                          {this.props.flag
                            ? t`Suggested categories`
                            : this.props.category}
                        </p>
                      </div>
                      <ul className="list">
                        {this.state.searchResults.navigation_items.map(el => {
                          return (
                            <li key={el.name}>
                              <a
                                className={`${
                                  this.props.flag ? 'result-new' : 'result'
                                }`}
                                href={`${el.url}?search_query=${this.state.inputValue}`}
                              >
                                <span>{el.name}</span>
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                {this.state.searchResults &&
                  this.state.searchResults.products.length > 0 && (
                    <div
                      className="product-results"
                      data-testid="product-results"
                    >
                      <div
                        className={`${
                          this.props.flag ? 'header-new' : 'header'
                        }`}
                      >
                        <p>
                          {this.props.flag ? t`Products` : this.props.products}
                        </p>
                      </div>
                      <ul className="list">{this.renderSearchResults()}</ul>
                    </div>
                  )}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
